export default __webpack_public_path__ + "static/media/icon-back.59aacba3.svg";